<form [formGroup]="searchForm" class="search-field">
  <div class="form-inline">
    <input class="form-control search" type="text" formControlName="filter" [placeholder]="placeholderText | translate "/>
    <span class="e-icons icon-search"></span>
  </div>
</form>
